export default "__VITE_ASSET__3ae8adc5__"